import React, { Component } from "react";
import { GET, POST, loading, alert, tokens, float, required, Select } from "../components/CustomComponent.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import TH_PROVINCE from "../assets/files/th_province.json";

const initialDealerForm = {
  applicant_type: "",
  contact_name_th: "",
  contact_name_en: "",
  contact_position: "",
  company_name: "",
  store_name: "",
  personal_id: "",
  tax_id: "",
  phone: "",
  email: "",
  line_id: "",
  website: "",
  business_type: "",
  province: "",
  district: "",
  sub_district: "",
  zipcode: "",
  address: "",
  shipping_address: "",
  monthly_order_estimate: "",
  business_detail: "",
};

const dealerTerms = [
  "1. บริษัทแต่งตั้งตัวแทนแบบ ไม่ผูกขาด (Non-exclusive) และห้ามอ้างสิทธิ์เป็นตัวแทนแต่เพียงผู้เดียว",
  "2. คุณสมบัติตัวแทนจำหน่ายภายใต้ร้านค้า",
  "2.1 ต้องเป็นบุคคลหรือบริษัทที่จดทะเบียนถูกต้อง",
  "2.2 ต้องมีความสามารถด้านการขาย / การตลาด พร้อมประสบการณ์และไม่เป็นผู้ติด Blacklist ปปง.",
  "2.3 ต้องยืนยันตัวตนและร้านค้า โดยปฏิบัติตามกฎหมายที่เกี่ยวข้อง",
  "3. การกำหนดราคาและส่วนค่าคอมมิชชั่น",
  "3.1 บริษัทฯ เป็นผู้กำหนดราคาส่ง (Wholesale Price)และค่าคอมมิชชั่นตามเงื่อนไข",
  "3.2 ตัวแทนสามารถตั้งราคาขายได้ แต่ต้องไม่ทำลายภาพลักษณ์แบรนด์ และห้ามตัดราคา (Price Dumping) รายอื่น",
  "4. ข้อกำหนดในการสั่งซื้อและชำระเงิน",
  "4.1 ต้องชำระเงินก่อนสั่งซื้อ (Prepaid)",
  "4.2 ไม่สามารถยกเลิกหรือคืนเงินหลังยืนยันคำสั่งซื้อ",
  "5. ข้อกำหนดในการตลาดและการส่งเสริมการขายสินค้า",
  "5.1 ตัวแทนจำหน่ายต้องนำเสนอสินค้าอย่างถูกต้อง และห้ามใช้ข้อมูลเท็จหรือเกินจริง",
  "5.2 ตัวแทนจำหน่ายต้องแจ้งช่องทางสื่อโฆษณาเช่น Line / Facebook ต้องได้รับอนุญาตจากบริษัทฯก่อนเท่านั้น",
  "6. กำหนดพื้นที่ขายสินค้า",
  "6.1 ตัวแทนผู้จำหน่ายจะต้องขายได้ตามพื้นที่หรือช่องทางที่บริษัทฯ เป็นผู้กำหนดโดยผู้ตัดสินของบริษัทฯ เป็นที่สิ้นสุด",
  "6.2 ตัวแทนจำหน่ายสามารถขายสินค้าผ่านช่องทางออนไลน์ต้องเป็นไปตามนโยบายที่บริษัทฯกำหนด",
  "7. การจัดส่งสินค้าทางบริษัทฯ มีการกำหนดระยะเวลาในการจัดส่งโดยกำหนดระยะเวลาตามเงื่อนไขของผู้ผลิตและติดตามตามช่วงเวลาที่กำหนด และบริษัทไม่รับผิดชอบความล่าช้า กรณีเกิดเหตุสุดวิสัย เช่น ภัยธรรมชาติ การก่ออาชญากรรม หรือภัยจากสงคราม",
  "8. การรับประกัน / เคลมสินค้า โดยเป็นไปตามเงื่อนไขบริษัทหรือผู้ผลิตเท่านั้น โดยบริษัทฯ จะรีบแจ้งเคลมภายใน 30 - 60 วันทำการ หลังจากส่งสินค้าให้ตัวแทนจำหน่าย ถ้าเกิดหลังจากนั้น ทางบริษัทฯ จะพิจารณาเป็นกรณี",
  "9. การใช้แบรนด์หรือโลโก้ / แบรนด์ได้ตามที่อนุญาต และห้ามดัดแปลงหรือใช้ผิดวัตถุประสงค์",
  "10. ตัวแทนผู้จัดจำหน่าย ห้ามขายสินค้าปลอม หรือห้ามให้ข้อมูลผิด หรือห้ามทำให้แบรนด์เสียหาย ถ้าทางบริษัทฯ พบเจอ จะดำเนินการทางกฏหมายในโทษสูงสุด และเรียกค่าปรับที่เกิดขึ้นมูลค่า 10 เท่าของความเสียหาย",
  "11. บริษัทฯ สามารถยกเลิกการเป็นตัวแทนทางบริษัทฯได้ทันที ถ้าพบข้อสงสัย หรือการทุจริต หรือการกระทำที่ไม่โปร่งใส และจะต้องหยุดใช้แบรนด์และหยุดขายทันทีภายใน 24 ชั่วโมง โดยคำตัดสินของบริษัทฯ เป็นที่สิ้นสุด",
  "12. ข้อจำกัดความรับผิด โดยบริษัทฯ รับผิดไม่เกินมูลค่าสินค้าในการสั่งซื้อแต่ละครั้ง",
];

const pricingSections = [
  {
    key: "base-pricing",
    title: "1. การกำหนดราคาพื้นฐานสินค้า",
    subtitle: "Base Pricing Model",
    columns: ["NO", "รายการ", "ราคา (บาท)", "Markup"],
    rows: [
      ["1", "ราคาตัวแทน (Standard)", "500,000", "10%"],
      ["2", "ราคาดีลเลอร์ (Dealer)", "2,000,000", "15%"],
      ["3", "ราคาดีลเลอร์ใหญ่ (Master Dealer)", "5,000,000", "20%"],
    ],
  },
  {
    key: "margin-model",
    title: "2. วิธีการคำนวณ Margin และกำไรตัวแทน",
    subtitle: "Margin and Dealer Profit",
    columns: ["NO", "ประเภท", "ราคาซื้อ", "Markup(%)", "ราคาขาย"],
    rows: [
      ["1", "ตัวแทนทั่วไป (Standard)", "500,000", "10%", "550,000"],
      ["2", "Dealer", "2,000,000", "15%", "2,300,000"],
      ["3", "Master Dealer", "5,000,000", "20%", "6,000,000"],
    ],
  },
  {
    key: "commission-structure",
    title: "3. โครงสร้างค่าคอมมิชชั่น",
    subtitle: "Commission Structure",
    columns: ["NO", "ยอดขาย / เดือน", "คอมมิชชั่น", "ตัวอย่างการคำนวณค่าคอม"],
    rows: [
      ["1", "ขั้นต่ำ 100,000 - 2,000,000 บาท", "5%", "ขายได้ 5 แสนบาทต่อเดือน = 25,000.00"],
      ["2", "2,000,001 - 5,000,000 บาท", "8%", "ขายได้ 3 ล้านบาทต่อเดือน = 240,000.00"],
      ["3", "5,000,001 บาทขึ้นไป", "10%", "ขายได้ 5 ล้านบาทต่อเดือน = 500,000.00"],
    ],
  },
];

export default class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registerType: "",
      hoveredType: "",
      dealerTermsRead: false,
      activePricingSection: "",
      name_th: "",
      name_en: "",
      phone: "",
      company_address: "",
      email: "",
      password: "",
      password_view: "password",
      dealerForm: { ...initialDealerForm },
    };
  }

  async componentDidMount() {
    if (tokens) {
      const result = await GET("v1/admin/users/profile");
      if (result?.status) {
        window.location.href = `/main`;
      }
    }
    loading(false);
  }

  Register = async () => {
    const { name_th, name_en, phone, company_address, email, password } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!name_th) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ-นามสกุล");
      return;
    } else if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรศัพท์");
      return;
    } else if (phone.length < 9) {
      alert("", "warning", "แจ้งเตือน", "เบอร์โทรศัพท์ไม่ถูกต้อง");
      return;
    } else if (!company_address) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกที่อยู่");
      return;
    } else if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    } else if (!emailRegex.test(email)) {
      alert("", "warning", "แจ้งเตือน", "รูปแบบอีเมลไม่ถูกต้อง");
      return;
    } else if (!password) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสผ่าน");
      return;
    } else if (password.length < 6) {
      alert("", "warning", "แจ้งเตือน", "รหัสผ่านต้องมากกว่า 6 ตัวอักษรขึ้นไป");
      return;
    }

    loading(true);
    const result = await POST("v1/public/market/customer", {
      name_th,
      name_en: name_th,
      phone,
      company_address,
      email,
      password,
    });
    if (result?.status === true) {
      alert("/login", "success");
    }
    loading(false);
  };

  handleDealerChange = (field, value) => {
    this.setState((prevState) => ({
      dealerForm: {
        ...prevState.dealerForm,
        [field]: value,
      },
    }));
  };

  getProvinceOptions = () => TH_PROVINCE || [];
  getDistrictOptions = (provinceName) =>
    this.getProvinceOptions().find((item) => item.th === provinceName)?.district || [];
  getSubDistrictOptions = (provinceName, districtName) =>
    this.getDistrictOptions(provinceName).find((item) => item.th === districtName)?.sub_district || [];
  getProvinceSelectOptions = () =>
    this.getProvinceOptions().map((item) => ({
      value: item.th,
      label: item.th,
    }));
  getDistrictSelectOptions = (provinceName) =>
    this.getDistrictOptions(provinceName).map((item) => ({
      value: item.th,
      label: item.th,
    }));
  getSubDistrictSelectOptions = (provinceName, districtName) =>
    this.getSubDistrictOptions(provinceName, districtName).map((item) => ({
      value: item.th,
      label: item.th,
    }));
  handleDealerProvinceChange = (province) => {
    this.setState((prevState) => ({
      dealerForm: {
        ...prevState.dealerForm,
        province,
        district: "",
        sub_district: "",
        zipcode: "",
      },
    }));
  };
  handleDealerDistrictChange = (district) => {
    this.setState((prevState) => ({
      dealerForm: {
        ...prevState.dealerForm,
        district,
        sub_district: "",
        zipcode: "",
      },
    }));
  };
  handleDealerSubDistrictChange = (subDistrict) => {
    this.setState((prevState) => {
      const selectedSubDistrict = this.getSubDistrictOptions(
        prevState.dealerForm.province,
        prevState.dealerForm.district
      ).find((item) => item.th === subDistrict);

      return {
        dealerForm: {
          ...prevState.dealerForm,
          sub_district: subDistrict,
          zipcode: selectedSubDistrict?.code?.toString() || "",
        },
      };
    });
  };

  handleDealerTermsScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const reachedBottom = scrollTop + clientHeight >= scrollHeight - 4;

    if (reachedBottom && !this.state.dealerTermsRead) {
      this.setState({ dealerTermsRead: true });
    }
  };

  setActivePricingSection = (activePricingSection) => {
    this.setState({ activePricingSection });
  };

  resetRegisterState = () => {
    this.setState({
      registerType: "",
      hoveredType: "",
      dealerTermsRead: false,
      activePricingSection: "",
      name_th: "",
      name_en: "",
      phone: "",
      company_address: "",
      email: "",
      password: "",
      password_view: "password",
      dealerForm: { ...initialDealerForm },
    });
  };

  submitDealerRegister = () => {
    const { dealerForm, dealerTermsRead } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!dealerTermsRead) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลื่อนอ่านเงื่อนไขการแต่งตั้งตัวแทนจำหน่ายภายใต้ร้านค้าให้ครบก่อน");
      return;
    } else if (!dealerForm.applicant_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทผู้สมัคร");
      return;
    } else if (dealerForm.applicant_type === "general" && !dealerForm.contact_name_th) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ-นามสกุล(ไทย)");
      return;
    } else if (dealerForm.applicant_type === "general" && !dealerForm.personal_id) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเลขบัตรประชาชน");
      return;
    } else if (dealerForm.applicant_type === "general" && dealerForm.personal_id.length !== 13) {
      alert("", "warning", "แจ้งเตือน", "เลขบัตรประชาชนต้องมี 13 หลัก");
      return;
    } else if (dealerForm.applicant_type === "juristic" && !dealerForm.company_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อบริษัท / นิติบุคคล");
      return;
    } else if (dealerForm.applicant_type === "juristic" && !dealerForm.contact_name_th) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อผู้ติดต่อ(ไทย)");
      return;
    } else if (dealerForm.applicant_type === "juristic" && !dealerForm.tax_id) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเลขประจำตัวผู้เสียภาษี");
      return;
    } else if (dealerForm.applicant_type === "juristic" && dealerForm.tax_id.length !== 13) {
      alert("", "warning", "แจ้งเตือน", "เลขประจำตัวผู้เสียภาษีต้องมี 13 หลัก");
      return;
    } else if (!dealerForm.phone || dealerForm.phone.length < 9) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง");
      return;
    } else if (!dealerForm.email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    } else if (!emailRegex.test(dealerForm.email)) {
      alert("", "warning", "แจ้งเตือน", "รูปแบบอีเมลไม่ถูกต้อง");
      return;
    } else if (!dealerForm.province) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกจังหวัด");
      return;
    } else if (!dealerForm.district) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกอำเภอ");
      return;
    } else if (!dealerForm.sub_district) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกตำบล");
      return;
    } else if (!dealerForm.zipcode) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกรหัสไปรษณีย์จากตำบล");
      return;
    } else if (!dealerForm.address) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกที่อยู่บริษัท / ร้านค้า");
      return;
    }

    alert(
      "",
      "info",
      "บันทึกแบบร่างสำเร็จ",
      "ฟอร์มสมัครสมาชิกตัวแทนจำหน่าย ยังไม่เปิดใช้งาน"
    );
    loading(false);
  };

  renderTextInput = ({
    label,
    placeholder,
    value,
    onChange,
    type = "text",
    maxLength,
    requiredField = false,
    readOnly = false,
  }) => (
    <>
      <label className="mb-1">
        {label}
        {requiredField ? required : ""}
      </label>
      <input
        className="form-control mb-3"
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        maxLength={maxLength}
        readOnly={readOnly}
      />
    </>
  );

  renderTextarea = ({
    label,
    placeholder,
    value,
    onChange,
    rows = 4,
    requiredField = false,
  }) => (
    <>
      <label className="mb-1">
        {label}
        {requiredField ? required : ""}
      </label>
      <textarea
        className="form-control mb-3"
        rows={rows}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </>
  );

  renderRegisterTypeSelector = () => {
    const { hoveredType } = this.state;
    const cardClass = "rounded-4 p-4 h-100 pointer bg-white d-flex flex-column justify-content-between";
    const getCardStyle = (type) => ({
      border: hoveredType === type ? "1px solid #ea580c" : "1px solid #ced4da",
      outline: hoveredType === type ? "2px solid rgba(234, 88, 12, 0.18)" : "none",
      outlineOffset: "0",
      boxShadow: hoveredType === type ? "0 1rem 2.5rem rgba(234, 88, 12, 0.22)" : "0 .125rem .25rem rgba(0, 0, 0, 0.075)",
      transform: hoveredType === type ? "translateY(-2px)" : "translateY(0)",
      transition: "all 0.2s ease",
    });

    return (
        <>
            <h3 className="fw-bold text-dark mb-3">สมัครสมาชิก</h3>
            <div className="mb-4">
                <small>เลือกประเภทสมาชิกก่อนเข้าสู่แบบฟอร์ม เพื่อให้เราแสดงข้อมูลที่เหมาะกับการใช้งานของคุณ</small>
            </div>
            <div className="row g-3">
                <div className="col-12 col-lg-6">
                    <div
                        className={cardClass}
                        style={getCardStyle("customer")}
                        onClick={() => {
                            this.setState({ registerType: "customer" });
                        }}
                        onMouseEnter={() => {
                            this.setState({ hoveredType: "customer" });
                        }}
                        onMouseLeave={() => {
                            this.setState({ hoveredType: "" });
                        }}
                    >
                        <div>
                            <h5 className="text-orange fw-bold mb-2">สมาชิกทั่วไป</h5>
                            <div className="fw-bold text-dark">สั่งซื้อสินค้าต่างๆ ได้ทันที</div>
                            <div className="text-secondary mt-2">เหมาะสำหรับลูกค้าทั่วไปที่ต้องการสมัครเพื่อสั่งซื้อสินค้าต่างๆ ในระบบ</div>
                        </div>
                        <button type="button" className="btn btn-outline-dark mt-4">
                            เลือกสมัครสมาชิกทั่วไป
                        </button>
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div
                        className={cardClass}
                        style={{...getCardStyle("dealer"), opacity: 0.2}}
                        onClick={() => {
                            // this.setState({ registerType: "dealer" });
                            alert("","info","แจ้งเตือน","การสมัครตัวแทนจำหน่ายจะเปิดให้สมัครในเร็วๆนี้")
                        }}
                        onMouseEnter={() => {
                            this.setState({ hoveredType: "dealer" });
                        }}
                        onMouseLeave={() => {
                            this.setState({ hoveredType: "" });
                        }}
                    >
                        <div>
                            <h5 className="text-orange fw-bold mb-2">ตัวแทนจำหน่าย</h5>
                            <div className="fw-bold text-dark">ส่งข้อมูลธุรกิจเพื่อให้ทีมงานพิจารณา</div>
                            <div className="text-secondary mt-2">เหมาะสำหรับร้านค้า บริษัท หรือผู้แทนที่ต้องการสมัครเข้าร่วมเป็นตัวแทนจำหน่ายกับระบบ</div>
                        </div>
                        <button type="button" className="btn btn-outline-dark mt-4">
                            เลือกสมัครตัวแทนจำหน่าย
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
  };

  renderPricingSection = (section, isActive) => {
    const headerStyle = {
      backgroundColor: isActive ? "#fff3cd" : "#ffffff",
      border: isActive ? "1px solid #f59e0b" : "1px solid #dee2e6",
      transition: "all 0.2s ease",
    };

    return (
      <div key={section.key} className="mb-3">
        <button
          type="button"
          className="w-100 text-start rounded-4 px-3 py-3 bg-white"
          style={headerStyle}
          onClick={() => this.setActivePricingSection(isActive ? "" : section.key)}
        >
          <div className="d-flex justify-content-between align-items-center gap-3">
            <div>
              <div className="fw-bold text-dark">{section.title}</div>
              <div className="small text-secondary">{section.subtitle}</div>
            </div>
            <div className="fw-bold text-orange">{isActive ? "ปิด" : "ดูรายละเอียด"}</div>
          </div>
        </button>
        {isActive && (
          <div className="border border-top-0 rounded-bottom-4 bg-white p-3 p-md-4">
            <div className="small text-secondary mb-3">โครงสร้างราคาตัวแทน (Distributor Pricing Structure)</div>
            <div className="table-responsive">
              <table className="table table-bordered align-middle mb-0">
                <thead>
                  <tr style={{ backgroundColor: "#fff200" }}>
                    {section.columns.map((column) => (
                      <th key={column} className="text-nowrap fw-bold text-dark text-center">
                        {column}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {section.rows.map((row, rowIndex) => (
                    <tr key={`${section.key}-${rowIndex}`}>
                      {row.map((cell, cellIndex) => (
                        <td
                          key={`${section.key}-${rowIndex}-${cellIndex}`}
                          className={`${cellIndex === 0 ? "text-center" : ""} ${cellIndex > 1 ? "text-end" : ""} fw-semibold`}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  };

  renderApplicantTypeOption = (value, title, description) => {
    const isActive = this.state.dealerForm.applicant_type === value;

    return (
      <label className="col-12 col-md-6">
        <input
          type="radio"
          name="applicant_type"
          value={value}
          checked={isActive}
          onChange={(e) => this.handleDealerChange("applicant_type", e.target.value)}
          className="d-none"
        />
        <div
          className="rounded-4 p-3 h-100 pointer bg-white"
          style={{
            border: isActive ? "2px solid #ea580c" : "1px solid #ced4da",
            boxShadow: isActive ? "0 .75rem 1.75rem rgba(234, 88, 12, 0.12)" : "0 .125rem .25rem rgba(0, 0, 0, 0.05)",
            transition: "all 0.2s ease",
          }}
        >
          <div className="d-flex align-items-start gap-3">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                width: 22,
                height: 22,
                marginTop: 2,
                border: isActive ? "6px solid #ea580c" : "2px solid #adb5bd",
                transition: "all 0.2s ease",
              }}
            />
            <div>
              <div className="fw-bold text-dark">{title}</div>
              <div className="small text-secondary">{description}</div>
            </div>
          </div>
        </div>
      </label>
    );
  };

  renderCustomerForm = () => {
    const { name_th, name_en, phone, company_address, email, password, password_view } = this.state;

    return (
      <>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h3 className="fw-bold text-dark mb-2">สมัครสมาชิกทั่วไป</h3>
          </div>
          <button
            type="button"
            className="btn btn-link text-secondary text-decoration-none p-0"
            onClick={() => {
              this.resetRegisterState();
            }}
          >
            เปลี่ยนประเภทสมาชิก
          </button>
        </div>
        {this.renderTextInput({
          label: "ชื่อ-นามสกุล",
          placeholder: "ชื่อ-นามสกุล",
          value: name_th,
          onChange: (e) => this.setState({ name_th: e.target.value }),
          requiredField: true,
        })}
        {/* {this.renderTextInput({
          label: "ชื่อ-นามสกุล(EN)",
          placeholder: "ชื่อ-นามสกุล(EN)",
          value: name_en,
          onChange: (e) => this.setState({ name_en: e.target.value }),
          requiredField: true,
        })} */}
        {this.renderTextInput({
          label: "เบอร์โทรติดต่อ",
          placeholder: "เบอร์โทรติดต่อ",
          value: phone,
          onChange: (e) => {
            if (!float(e.target.value)) return;
            this.setState({ phone: e.target.value });
          },
          maxLength: 10,
          requiredField: true,
        })}
        {this.renderTextarea({
          label: "ที่อยู่สำหรับการจัดส่งสินค้า",
          placeholder: "ที่อยู่สำหรับการจัดส่งสินค้า",
          value: company_address,
          onChange: (e) => this.setState({ company_address: e.target.value }),
          rows: 5,
          requiredField: true,
        })}
        {this.renderTextInput({
          label: "อีเมล",
          placeholder: "อีเมล",
          value: email,
          onChange: (e) => this.setState({ email: e.target.value }),
          type: "email",
          requiredField: true,
        })}
        <label className="mb-1">
          รหัสผ่าน
          {required}
        </label>
        <div className="position-relative">
          <input
            className="form-control mb-3"
            type={password_view}
            placeholder="รหัสผ่าน"
            onChange={(e) => {
              this.setState({ password: e.target.value });
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                this.Register();
              }
            }}
            value={password}
          />
          <div
            className="wpx-40 hpx-40 d-flex justify-content-center align-items-center icon pointer position-absolute"
            style={{ right: 0, top: -2 }}
            onClick={() => {
              this.setState({
                password_view: password_view === "password" ? "text" : "password",
              });
            }}
          >
            {password_view === "password" ? "\uf06e" : "\uf070"}
          </div>
        </div>
        <button
          type="button"
          className="btn btn-dark w-100 mb-3"
          onClick={() => {
            this.Register();
          }}
        >
          สมัครสมาชิก
        </button>
      </>
    );
  };

  renderDealerForm = () => {
    const { dealerForm, dealerTermsRead, activePricingSection } = this.state;
    const provinceOptions = this.getProvinceSelectOptions();
    const districtOptions = this.getDistrictSelectOptions(dealerForm.province);
    const subDistrictOptions = this.getSubDistrictSelectOptions(dealerForm.province, dealerForm.district);

    return (
      <>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h3 className="fw-bold text-dark mb-2">สมัครสมาชิกตัวแทนจำหน่าย</h3>
            <small>กรอกข้อมูลธุรกิจเบื้องต้นเพื่อให้ทีมงานติดต่อกลับและพิจารณาการสมัคร</small>
          </div>
          <button
            type="button"
            className="btn btn-link text-secondary text-decoration-none p-0"
            onClick={() => {
              this.resetRegisterState();
            }}
          >
            เปลี่ยนประเภทสมาชิก
          </button>
        </div>
        <div className="row">
          <div className="col-12">
            <label className="mb-1">
              ประเภทผู้สมัคร
              {required}
            </label>
            <div className="row g-3 mb-3">
              {this.renderApplicantTypeOption(
                "general",
                "ทั่วไป",
                "เหมาะสำหรับผู้สมัครรายบุคคลหรือเจ้าของร้านที่สมัครในนามบุคคล"
              )}
              {this.renderApplicantTypeOption(
                "juristic",
                "นิติบุคคล",
                "เหมาะสำหรับบริษัทหรือกิจการที่จดทะเบียนและสมัครในนามองค์กร"
              )}
            </div>
          </div>
          {dealerForm.applicant_type === "general" && (
            <>
              <div className="col-12 col-md-6">
                {this.renderTextInput({
                  label: "ชื่อ-นามสกุล(ไทย)",
                  placeholder: "ชื่อ-นามสกุล(ไทย)",
                  value: dealerForm.contact_name_th,
                  onChange: (e) => this.handleDealerChange("contact_name_th", e.target.value),
                  requiredField: true,
                })}
              </div>
              <div className="col-12 col-md-6">
                {this.renderTextInput({
                  label: "ชื่อ-นามสกุล(EN)",
                  placeholder: "ชื่อ-นามสกุล(EN)",
                  value: dealerForm.contact_name_en,
                  onChange: (e) => this.handleDealerChange("contact_name_en", e.target.value),
                })}
              </div>
              <div className="col-12 col-md-6">
                {this.renderTextInput({
                  label: "เลขบัตรประชาชน",
                  placeholder: "เลขบัตรประชาชน 13 หลัก",
                  value: dealerForm.personal_id,
                  onChange: (e) => {
                    if (!float(e.target.value)) return;
                    this.handleDealerChange("personal_id", e.target.value);
                  },
                  maxLength: 13,
                  requiredField: true,
                })}
              </div>
              <div className="col-12 col-md-6">
                {this.renderTextInput({
                  label: "ชื่อร้านค้า / ชื่อที่ใช้ขาย",
                  placeholder: "ชื่อร้านค้า / ชื่อที่ใช้ขาย",
                  value: dealerForm.store_name,
                  onChange: (e) => this.handleDealerChange("store_name", e.target.value),
                })}
              </div>
            </>
          )}
          {dealerForm.applicant_type === "juristic" && (
            <>
              <div className="col-12 col-md-6">
                {this.renderTextInput({
                  label: "ชื่อบริษัท / นิติบุคคล",
                  placeholder: "ชื่อบริษัท / นิติบุคคล",
                  value: dealerForm.company_name,
                  onChange: (e) => this.handleDealerChange("company_name", e.target.value),
                  requiredField: true,
                })}
              </div>
              <div className="col-12 col-md-6">
                {this.renderTextInput({
                  label: "เลขประจำตัวผู้เสียภาษี",
                  placeholder: "เลขประจำตัวผู้เสียภาษี 13 หลัก",
                  value: dealerForm.tax_id,
                  onChange: (e) => {
                    if (!float(e.target.value)) return;
                    this.handleDealerChange("tax_id", e.target.value);
                  },
                  maxLength: 13,
                  requiredField: true,
                })}
              </div>
              <div className="col-12 col-md-6">
                {this.renderTextInput({
                  label: "ชื่อผู้ติดต่อ(ไทย)",
                  placeholder: "ชื่อผู้ติดต่อ(ไทย)",
                  value: dealerForm.contact_name_th,
                  onChange: (e) => this.handleDealerChange("contact_name_th", e.target.value),
                  requiredField: true,
                })}
              </div>
              <div className="col-12 col-md-6">
                {this.renderTextInput({
                  label: "ชื่อผู้ติดต่อ(EN)",
                  placeholder: "ชื่อผู้ติดต่อ(EN)",
                  value: dealerForm.contact_name_en,
                  onChange: (e) => this.handleDealerChange("contact_name_en", e.target.value),
                })}
              </div>
              <div className="col-12 col-md-6">
                {this.renderTextInput({
                  label: "ตำแหน่งผู้ติดต่อ",
                  placeholder: "ตำแหน่งผู้ติดต่อ",
                  value: dealerForm.contact_position,
                  onChange: (e) => this.handleDealerChange("contact_position", e.target.value),
                })}
              </div>
            </>
          )}
          {!dealerForm.applicant_type && (
            <div className="col-12">
              <div className="alert alert-light border mb-3">
                <small className="text-secondary">กรุณาเลือกประเภทผู้สมัครก่อน ระบบจะแสดงช่องกรอกข้อมูลที่เหมาะสมให้โดยอัตโนมัติ</small>
              </div>
            </div>
          )}
          <div className="col-12 col-md-6">
            {this.renderTextInput({
              label: "เบอร์โทรศัพท์",
              placeholder: "เบอร์โทรศัพท์",
              value: dealerForm.phone,
              onChange: (e) => {
                if (!float(e.target.value)) return;
                this.handleDealerChange("phone", e.target.value);
              },
              maxLength: 10,
              requiredField: true,
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.renderTextInput({
              label: "อีเมลติดต่อ",
              placeholder: "อีเมลติดต่อ",
              value: dealerForm.email,
              onChange: (e) => this.handleDealerChange("email", e.target.value),
              type: "email",
              requiredField: true,
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.renderTextInput({
              label: "Line ID",
              placeholder: "Line ID",
              value: dealerForm.line_id,
              onChange: (e) => this.handleDealerChange("line_id", e.target.value),
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.renderTextInput({
              label: "เว็บไซต์ / Facebook Page",
              placeholder: "เว็บไซต์ / Facebook Page",
              value: dealerForm.website,
              onChange: (e) => this.handleDealerChange("website", e.target.value),
            })}
          </div>
          <div className="col-12 col-md-6">
            <label className="mb-1">ประเภทธุรกิจ</label>
            <select
              className="form-select mb-3"
              value={dealerForm.business_type}
              onChange={(e) => this.handleDealerChange("business_type", e.target.value)}
            >
              <option value="">เลือกประเภทธุรกิจ</option>
              <option value="retail">ร้านค้าปลีก</option>
              <option value="wholesale">ร้านค้าส่ง</option>
              <option value="online">ร้านค้าออนไลน์</option>
              <option value="service">ธุรกิจบริการ</option>
              <option value="other">อื่นๆ</option>
            </select>
          </div>
          <div className="col-12 col-md-6">
            <label className="mb-1">
              จังหวัด
              {required}
            </label>
            <Select
              className="form-control mb-3"
              options={provinceOptions}
              value={dealerForm.province}
              placeholder="เลือกจังหวัด"
              onChange={(value) => this.handleDealerProvinceChange(value)}
            />
          </div>
          <div className="col-12 col-md-6">
            <label className="mb-1">
              อำเภอ
              {required}
            </label>
            <Select
              className="form-control mb-3"
              options={districtOptions}
              value={dealerForm.district}
              placeholder="เลือกอำเภอ"
              onChange={(value) => this.handleDealerDistrictChange(value)}
              disabled={!dealerForm.province}
            />
          </div>
          <div className="col-12 col-md-6">
            <label className="mb-1">
              ตำบล
              {required}
            </label>
            <Select
              className="form-control mb-3"
              options={subDistrictOptions}
              value={dealerForm.sub_district}
              placeholder="เลือกตำบล"
              onChange={(value) => this.handleDealerSubDistrictChange(value)}
              disabled={!dealerForm.province || !dealerForm.district}
            />
          </div>
          <div className="col-12 col-md-6">
            {this.renderTextInput({
              label: "รหัสไปรษณีย์",
              placeholder: "รหัสไปรษณีย์จะขึ้นอัตโนมัติ",
              value: dealerForm.zipcode,
              onChange: () => {},
              maxLength: 10,
              readOnly: true,
            })}
          </div>
          <div className="col-12">
            {this.renderTextarea({
              label: "ที่อยู่บริษัท / ร้านค้า",
              placeholder: "ที่อยู่บริษัท / ร้านค้า",
              value: dealerForm.address,
              onChange: (e) => this.handleDealerChange("address", e.target.value),
              rows: 4,
              requiredField: true,
            })}
          </div>
          <div className="col-12">
            {this.renderTextarea({
              label: "ที่อยู่สำหรับรับสินค้า",
              placeholder: "ที่อยู่สำหรับรับสินค้า (ถ้ามี)",
              value: dealerForm.shipping_address,
              onChange: (e) => this.handleDealerChange("shipping_address", e.target.value),
              rows: 4,
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.renderTextInput({
              label: "ประมาณการยอดสั่งซื้อ / เดือน",
              placeholder: "เช่น 50,000 - 100,000 บาท",
              value: dealerForm.monthly_order_estimate,
              onChange: (e) => this.handleDealerChange("monthly_order_estimate", e.target.value),
            })}
          </div>
          <div className="col-12">
            {this.renderTextarea({
              label: "รายละเอียดเพิ่มเติมเกี่ยวกับธุรกิจ",
              placeholder: "เล่ารูปแบบธุรกิจ ช่องทางการขาย หรือข้อมูลที่อยากให้ทีมงานทราบเพิ่มเติม",
              value: dealerForm.business_detail,
              onChange: (e) => this.handleDealerChange("business_detail", e.target.value),
              rows: 5,
            })}
          </div>
        </div>
        <div className="mt-3 mb-4">
          <div className="rounded-4 p-3 p-md-4" style={{ background: "linear-gradient(180deg, #fffaf0 0%, #ffffff 100%)", border: "1px solid #f3e2b3" }}>
            <div className="mb-3">
              <div className="fw-bold text-dark">โครงสร้างราคาตัวแทน</div>
              <small className="text-secondary">กดดูรายละเอียดแต่ละหัวข้อเพื่อทำความเข้าใจราคา มาร์จิน และค่าคอมมิชชั่นเบื้องต้น</small>
            </div>
            {pricingSections.map((section) => this.renderPricingSection(section, activePricingSection === section.key))}
          </div>
        </div>
        <div className="mt-2 mb-3">
          <label className="mb-2 fw-bold">เงื่อนไขการแต่งตั้งตัวแทนจำหน่ายภายใต้ร้านค้า{required}</label>
            <div
              className="border rounded-4 p-3 bg-white"
              style={{ maxHeight: 280, overflowY: "auto", borderColor: dealerTermsRead ? "#198754" : "#ced4da" }}
              onScroll={this.handleDealerTermsScroll}
            >
            {dealerTerms.map((term) => (
              <div
                key={term}
                className="text-secondary mb-2"
                style={{
                  paddingLeft: /^\d+\.\d+/.test(term) ? "1.5rem" : "0",
                }}
              >
                {term}
              </div>
            ))}
          </div>
          <div className={`small mt-2 ${dealerTermsRead ? "text-success" : "text-danger"}`}>
            {dealerTermsRead
              ? "อ่านเงื่อนไขครบแล้ว"
              : "กรุณาอ่านข้อความเงื่อนไขการแต่งตั้งตัวแทนจำหน่ายภายใต้ร้านค้า"}
          </div>
        </div>
        <button
          type="button"
          className={`btn ${dealerTermsRead ? "btn-dark" : "btn-secondary"} w-100 mb-3`}
          onClick={this.submitDealerRegister}
          disabled={!dealerTermsRead}
        >
          ส่งข้อมูลสมัครตัวแทนจำหน่าย
        </button>
      </>
    );
  };

  render() {
    const { registerType } = this.state;

    return !tokens ? (
      <div className="w-100 min-vh-100 bg-orange position-relative">
        <div className="row w-100 mx-0 min-vh-100 d-flex align-items-center">
          <div className="col-11 col-md-10 col-lg-8 col-xl-7 mx-auto my-5">
            <div className="bg-light rounded-4 shadow px-3 px-md-4 py-4">
              {!registerType && this.renderRegisterTypeSelector()}
              {registerType === "customer" && this.renderCustomerForm()}
              {registerType === "dealer" && this.renderDealerForm()}

              <div className="text-center mt-4">
                <a href="/login" className="text-secondary text-nowrap text-14 mx-1">
                  ย้อนกลับ
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }
}
